/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-async-promise-executor */
import connector from '../connector';

const addGroupsList = (groupsList) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('groups', 'readwrite');
        const groupsStore = transaction.objectStore('groups');

        groupsStore.clear(); // delete all of the previously added groups to add the new list

        groupsList.forEach(singleGroup => {
            groupsStore.add(singleGroup);
        });

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getGroupsList = () => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('groups', 'readonly');
        const groupsStore = transaction.objectStore('groups');

        const allGroups = groupsStore.getAll();

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: allGroups.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});


const getGroupsListByFarmId = ({ id }) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('groups', 'readonly');
        const groupsStore = transaction.objectStore('groups');
        const farmIdIndex = groupsStore.index('FarmIdIndex');

        const allGroups = farmIdIndex.getAll(id);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: allGroups.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});


const getGroupByName = ({ groupName, farmId }) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('groups', 'readonly');
        const groupsStore = transaction.objectStore('groups');
        const farmIdIndex = groupsStore.index('FarmIdIndex');

        const allGroups = farmIdIndex.getAll(farmId);

        transaction.oncomplete = () => {
            db.close();
            const isExist = allGroups?.result?.filter((singleGroup) => singleGroup.name === groupName);
            resolve({ success: true, data: isExist?.[0] || null });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});


const groups = {
    addGroupsList,
    getGroupsList,
    getGroupsListByFarmId,
    getGroupByName
}

export default groups;
